import React from "react"
import { connect } from "react-redux"
import _ from "../../utils/lodashUtils"
import { Redirect } from "react-router"

const Landing = (props) => {
  const userData = _.get(props, "auth.user", {}) || {}
  let targetRouteURL = "/"
  if (_.isEmpty(userData)) {
    return <Redirect to="/register" />
  }
  if (
    !userData.display_name &&
    !(
      userData.phone_number_verification_status ||
      userData.email_verification_status
    )
  ) {
    targetRouteURL = "/contact"
  } else {
    targetRouteURL = "/dashboard"
  }
  return <Redirect to={targetRouteURL} />
}

const mapStateToProps = (state) => ({
  auth: state.auth,
  partnerDetails: _.get(state, "invitePeople.partnerDetails", {}),
})

export default connect(mapStateToProps)(Landing)
